import React, { useState } from "react";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { DatePicker } from "rsuite";

// Sample patient data
const patientInfo = {
  name: "Dinesh",
  age: 22,
  gender: "male",
  phone: "9034578839",
  appointmentId: "376",
  doctor: "Myan",
  BedID: 2
};

// Patient Information Card Component
const PatientInfoCard = () => (
  <div className="patient-info-card">
    {/* Patient Header */}
    <div className="patient-header">
      <div className="patient-icon">
        <svg className="icon-user" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </svg>
      </div>
      <h3>Patient Information</h3>
    </div>

    {/* Search Container */}
    <div className="search-container">
      <input 
        type="text" 
        className="search-input" 
        placeholder="Search patient by name"
      />
      <svg className="search-icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
      </svg>
    </div>

    {/* Patient Details */}
    <div className="patient-card-content">
      <button className="close-btn">×</button>
      
      <div className="patient-name">{patientInfo.name}</div>
      <div className="patient-basic-info">
        Age: {patientInfo.age} • {patientInfo.gender}
      </div>
      <div className="patient-basic-info">
        <p>Doctor: {patientInfo.doctor}</p>
        <p>BedID: {patientInfo.BedID}</p>
      </div>
    </div>
  </div>
);

// Modified Vital Block for 2x2 layout
const VitalBlock = ({ index, data, onChange }) => (
  <div className="vitals-section-card">
    <div className="vitals-header">
      <h5>Vital Signs #{index}</h5>
    </div>
    <div className="vitals-2x2-grid">
      <div className="vital-field">
        <label>BP</label>
        <input
          type="text"
          placeholder="e.g. 120/80"
          value={data.BP || ""}
          onChange={(e) => onChange("BP", e.target.value)}
          className="vital-input"
        />
      </div>
      <div className="vital-field">
        <label>Pulse</label>
        <input
          type="text"
          placeholder="e.g. 72"
          value={data.Pulse || ""}
          onChange={(e) => onChange("Pulse", e.target.value)}
          className="vital-input"
        />
      </div>
      <div className="vital-field">
        <label>Temperature</label>
        <input
          type="text"
          placeholder="e.g. 98.6°F"
          value={data.Temp || ""}
          onChange={(e) => onChange("Temp", e.target.value)}
          className="vital-input"
        />
      </div>
      <div className="vital-field">
        <label>O2 Saturation</label>
        <input
          type="text"
          placeholder="e.g. 98%"
          value={data.O2 || ""}
          onChange={(e) => onChange("O2", e.target.value)}
          className="vital-input"
        />
      </div>
    </div>
  </div>
);

// Other block components remain the same
const MedicationWardBlock = ({ index, data, onChange, onDelete }) => (
  <div
    style={{
      padding: "1rem",
      marginBottom: "1rem",
      border: "1px solid #ddd",
      borderRadius: "6px",
    }}
  >
    <div className="block-header">
      <h5>Medication #{index}</h5>
      <button className="delete-btn" title="Remove Medication" onClick={onDelete}>
        <MdOutlineDeleteOutline color={"red"} />
      </button>
    </div>
    <div className="row">
      <div className="form-group col-md-4">
        <label>Medicine Name</label>
        <input
          type="text"
          placeholder="e.g. Aspirin"
          value={data.name || ""}
          className="inputstyle"
          onChange={(e) => onChange("name", e.target.value)}
        />
      </div>
      <div className="form-group col-md-4">
        <label>Dosage</label>
        <input
          type="text"
          placeholder="e.g. 100mg"
          value={data.dosage || ""}
          className="inputstyle"
          onChange={(e) => onChange("dosage", e.target.value)}
        />
      </div>
      <div className="form-group col-md-4">
        <label>Time</label>
        <input
          type="time"
          value={data.time || ""}
          className="inputstyle"
          onChange={(e) => onChange("time", e.target.value)}
        />
      </div>
    </div>
  </div>
);

const NursingNoteBlock = ({ index, data, onChange, onDelete }) => (
  <div
    style={{
      padding: "1rem",
      marginBottom: "1rem",
      border: "1px solid #ddd",
      borderRadius: "6px",
    }}
  >
    <div className="block-header">
      <h5>Nursing Note #{index}</h5>
      <button className="delete-btn" title="Remove Note" onClick={onDelete}>
        <MdOutlineDeleteOutline color={"red"} />
      </button>
    </div>
    <div className="row">
      <div className="form-group col-md-4">
        <label>Shift</label>
        <input
          type="text"
          placeholder="e.g. Morning"
          value={data.shift || ""}
          className="inputstyle"
          onChange={(e) => onChange("shift", e.target.value)}
        />
      </div>
      <div className="form-group col-md-4">
        <label>Nurse Name</label>
        <input
          type="text"
          placeholder="e.g. John Doe"
          value={data.nurse || ""}
          className="inputstyle"
          onChange={(e) => onChange("nurse", e.target.value)}
        />
      </div>
      <div className="form-group col-md-12">
        <label>Note</label>
        <textarea
          placeholder="Enter nursing observations and notes"
          value={data.note || ""}
          className="inputstyle"
          onChange={(e) => onChange("note", e.target.value)}
        />
      </div>
    </div>
  </div>
);

const DoctorRoundBlock = ({ index, data, onChange, onDelete }) => (
  <div
    style={{
      padding: "1rem",
      marginBottom: "1rem",
      border: "1px solid #ddd",
      borderRadius: "6px",
    }}
  >
    <div className="block-header">
      <h5>Doctor Round #{index}</h5>
      <button className="delete-btn" title="Remove Round" onClick={onDelete}>
        <MdOutlineDeleteOutline color={"red"} />
      </button>
    </div>
    <div className="row">
      <div className="form-group col-md-6">
        <label>Date & Time</label>
        <DatePicker
          format="dd-MMM-yyyy HH:mm"
          placeholder="Select date and time"
          value={data.date ? new Date(data.date) : null}
          oneTap
          onChange={(value) => onChange("date", value ? value.toISOString() : "")}
          style={{ width: '100%' }}
          placement="bottomStart"
        />
      </div>
      <div className="form-group col-md-6">
        <label>Doctor Name</label>
        <input
          type="text"
          placeholder="e.g. Dr. Smith"
          value={data.doctorName || ""}
          className="inputstyle"
          onChange={(e) => onChange("doctorName", e.target.value)}
        />
      </div>
      <div className="form-group col-md-12">
        <label>Observations</label>
        <textarea
          placeholder="Enter doctor's observations"
          value={data.observations || ""}
          className="inputstyle"
          onChange={(e) => onChange("observations", e.target.value)}
        />
      </div>
      <div className="form-group col-md-6">
        <label>Treatment Changes</label>
        <input
          type="text"
          placeholder="Any treatment modifications"
          value={data.treatmentChanges || ""}
          className="inputstyle"
          onChange={(e) => onChange("treatmentChanges", e.target.value)}
        />
      </div>
      <div className="form-group col-md-6">
        <label>Follow-Up Plan</label>
        <input
          type="text"
          placeholder="Next steps"
          value={data.followUpPlan || ""}
          className="inputstyle"
          onChange={(e) => onChange("followUpPlan", e.target.value)}
        />
      </div>
    </div>
  </div>
);

const LabTestBlock = ({ index, data, onChange, onDelete }) => (
  <div
    style={{
      padding: "1rem",
      marginBottom: "1rem",
      border: "1px solid #ddd",
      borderRadius: "6px",
    }}
  >
    <div className="block-header">
      <h5>Lab Test #{index}</h5>
      <button className="delete-btn" title="Remove Test" onClick={onDelete}>
        <MdOutlineDeleteOutline color={"red"} />
      </button>
    </div>
    <div className="row">
      <div className="form-group col-md-4">
        <label>Test Name</label>
        <input
          type="text"
          placeholder="e.g. Blood Test"
          value={data.test || ""}
          className="inputstyle"
          onChange={(e) => onChange("test", e.target.value)}
        />
      </div>
      <div className="form-group col-md-3">
        <label>Date</label>
        <input
          type="date"
          value={data.date || ""}
          className="inputstyle"
          onChange={(e) => onChange("date", e.target.value)}
        />
      </div>
      <div className="form-group col-md-12">
        <label>Result</label>
        <textarea
          placeholder="Enter test results"
          value={data.result || ""}
          className="inputstyle"
          onChange={(e) => onChange("result", e.target.value)}
        />
      </div>
    </div>
  </div>
);

function CareTrackingForm() {
  // Fixed: Changed from array [{...}] to object {...}
  const [formData, setFormData] = useState({
    vitals: [{ BP: "", Pulse: "", Temp: "", O2: "" }],
    medication: [{ name: "", dosage: "", time: "" }],
    nursingNotes: [{ shift: "", note: "", nurse: "" }],
    labTests: [{ test: "", requested: false, result: "", date: "" }],
    doctorRounds: [
      {
        date: "",
        doctorName: "",
        observations: "",
        treatmentChanges: "",
        followUpPlan: "",
      },
    ],
    dietPlan: "",
    specialInstructions: "",
  });

  const handleArrayChange = (section, index, field, value) => {
    const updated = [...formData[section]];
    updated[index][field] = value;
    setFormData((prev) => ({ ...prev, [section]: updated }));
  };

  const handleAddRow = (section) => {
    const empty =
      section === "vitals"
        ? { BP: "", Pulse: "", Temp: "", O2: "" }
        : section === "medication"
        ? { name: "", dosage: "", time: "" }
        : section === "nursingNotes"
        ? { shift: "", note: "", nurse: "" }
        : section === "labTests"
        ? { test: "", requested: false, result: "", date: "" }
        : section === "doctorRounds"
        ? {
            date: "",
            doctorName: "",
            observations: "",
            treatmentChanges: "",
            followUpPlan: "",
          }
        : {};

    setFormData((prev) => ({
      ...prev,
      [section]: [...prev[section], empty],
    }));
  };

  const handleDeleteRow = (section, index) => {
    setFormData((prev) => ({
      ...prev,
      [section]: prev[section].filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = () => {
    console.log("Submitted Data:", formData);
    alert("Care tracking details submitted successfully!");
  };

  const careStyles = `
    .care-form-container {
      width: 100%;
      margin: 0 auto;
      padding: 20px;
    }

    .form-header {
      text-align: start;
      margin-bottom: 2rem;
      font-weight: 700;
      color: #000;
      letter-spacing: 0.03em;
      font-size: 24px;
    }

    .top-section {
      display: flex;
      gap: 24px;
      margin-bottom: 2rem;
    }

    .patient-section {
      flex: 1;
      max-width: 400px;
    }

    .vitals-section {
      flex: 1;
    }

    /* Patient Information Card Styles */
    .patient-info-card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      overflow: hidden;
      height: fit-content;
    }

    .patient-header {
      background: #4a9b8e;
      color: white;
      padding: 16px 20px;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .patient-icon {
      background: rgba(255,255,255,0.2);
      padding: 8px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
    }

    .patient-header h3 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
    }

    .icon-user {
      width: 20px;
      height: 20px;
      fill: currentColor;
    }

    .search-container {
      padding: 8px 15px 8px 8px;
      border-bottom: 1px solid #e5e7eb;
      position: relative;
    }

    .search-input {
      width: 100%;
      padding: 5px;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      font-size: 14px;
      color: #6b7280;
      background-color: #f9fafb;
      margin: 5px;
    }

    .search-input:focus {
      outline: none;
      border-color: #4a9b8e;
      background-color: white;
    }

    .search-icon {
      position: absolute;
      right: 28px;
      top: 50%;
      transform: translateY(-50%);
      width: 18px;
      height: 18px;
      fill: #9ca3af;
    }

    .patient-card-content {
      background: #f0f9f8;
      padding: 10px;
      position: relative;
      margin: 10px;
      border-radius: 6px;
      border: 1px solid #59d199ff;
    }

    .close-btn {
      position: absolute;
      top: 15px;
      right: 15px;
      background: none;
      border: none;
      font-size: 18px;
      color: #6b7280;
      cursor: pointer;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
    }

    .close-btn:hover {
      background-color: rgba(0,0,0,0.1);
    }

    .patient-name {
      font-size: 1.3rem;
      font-weight: 700;
      color: #1f2937;
      margin-bottom: 4px;
    }

    .patient-basic-info {
      font-size: 0.9rem;
      color: #6b7280;
      margin-bottom: 5px;
      line-height: 1.4;
    }

    .patient-basic-info p {
      margin: 2px 0;
    }

    .patient-details-grid {
      display: grid;
      gap: 12px;
    }

    .detail-item {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .detail-label {
      font-size: 0.75rem;
      font-weight: 600;
      color: #374151;
      text-transform: uppercase;
      letter-spacing: 0.025em;
    }

    .detail-value {
      font-size: 0.9rem;
      color: #1f2937;
      font-weight: 500;
    }

    .view-details-link {
      display: inline-flex;
      align-items: center;
      color: #4a9b8e;
      font-size: 0.85rem;
      text-decoration: none;
      margin-top: 12px;
      font-weight: 500;
    }

    .view-details-link:hover {
      text-decoration: underline;
    }

    /* Vitals Section Styles */
    .vitals-section-card {
      background: white;
      padding: 18px;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
      border: 1px solid #e5e7eb;
      margin-bottom: 0rem;
    }

    .vitals-header {
      margin-bottom: 20px;
    }

    .vitals-header h5 {
      color: #4a9b8e;
      font-weight: 600;
      font-size: 1.1rem;
      margin: 0;
    }

    .vitals-2x2-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }

    .vital-field {
      display: flex;
      flex-direction: column;
    }

    .vital-field label {
      font-size: 0.9rem;
      font-weight: 600;
      color: #374151;
      margin-bottom: 8px;
    }

    .vital-input {
      padding: 12px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      font-size: 0.95rem;
      transition: all 0.2s ease;
    }

    .vital-input:focus {
      outline: none;
      border-color: #4a9b8e;
      box-shadow: 0 0 0 3px rgba(74, 155, 142, 0.1);
    }

    .vital-input::placeholder {
      color: #9ca3af;
    }

    .card {
      background: #fff;
      padding: 1.5rem;
      margin-bottom: 1.5rem;
      border-radius: 10px;
      box-shadow: 0 0 5px rgba(0,0,0,0.05);
    }

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1rem;
    }

    .section-header h4 {
      font-weight: 600;
      color: #4a9b8e;
      margin: 0;
    }

    .gradient-button {
      background: linear-gradient(90deg, #4a9b8e, #3d8b7d);
      color: white;
      border: none;
      border-radius: 6px;
      padding: 8px 16px;
      cursor: pointer;
      font-size: 0.9rem;
      transition: all 0.25s;
    }

    .gradient-button:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(74, 155, 142, 0.25);
    }

    .inputstyle {
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    .inputstyle:focus {
      border-color: #4a9b8e;
      box-shadow: 0 0 0 2px rgba(74, 155, 142, 0.15);
      outline: none;
    }

    .scroll-container {
      max-height: 450px;
      overflow-y: auto;
      padding-right: 8px;
    }

    .block-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1rem;
    }

    .block-header h5 {
      font-size: 1rem;
      font-weight: 600;
      margin: 0;
    }

    .delete-btn {
      background: none;
      border: none;
      font-size: 1.2rem;
      color: #e74c3c;
      cursor: pointer;
      padding: 4px;
    }

    .delete-btn:hover {
      background: #f8f9fa;
      border-radius: 4px;
    }

    input, textarea, select {
      width: 100%;
      padding: 0.5rem;
      margin-top: 0.3rem;
      margin-bottom: 1rem;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    textarea {
      resize: vertical;
      min-height: 80px;
    }

    label {
      font-weight: 500;
      color: #374151;
      font-size: 0.9rem;
    }

    .form-group {
      margin-bottom: 1rem;
    }

    .row {
      display: flex;
      flex-wrap: wrap;
    }

    .submit-container {
      text-align: start;
      margin-top: 0rem;
      padding: 1rem 0;
    }

    .submit-btn {
      background: linear-gradient(90deg, #4a9b8e, #3d8b7d);
      color: white;
      border: none;
      border-radius: 8px;
      padding: 14px 32px;
      cursor: pointer;
      font-size: 1.1rem;
      font-weight: 600;
      transition: all 0.25s;
      min-width: 200px;
    }

    .submit-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(74, 155, 142, 0.3);
    }

    .rs-input-group {
            border-radius: 8px !important;
            border: #e5e5ea solid 1px !important;
            height: 42px;
            overflow: hidden;
            background: white;
            margin-top: 0.3rem;
            margin-bottom: 1rem;
            padding-top: 5px
          }
          
          .rs-input-group .rs-input {
            border-radius: 5px !important;
            border: none !important;
            background: none !important;
            box-shadow: none !important;
          }
          
          .rs-input-group .rs-input:focus {
            outline: none;
            box-shadow: none;
          }
          
          .rs-picker-toggle {
            border-radius: 8px !important;
          }
          
          .rs-input-group-inside .rs-input {
            border: none !important;
            font-size: 14px;
            border-radius: 8px !important;
            box-shadow: none !important;
            background: none !important;
          }

  `;

  return (
    <>
      <style>{careStyles}</style>
      <div className="care-form-container">
        <h2 className="form-header">Care Tracking Form</h2>

        {/* Top Section: Patient Info Card + Vitals */}
        <div className="top-section">
          {/* Patient Vitals Section */}
          <div className="vitals-section">
            {formData.vitals.map((vital, idx) => (
              <VitalBlock
                key={idx}
                index={idx + 1}
                data={vital}
                onChange={(field, value) => handleArrayChange("vitals", idx, field, value)}
              />
            ))}
          </div>

          {/* Patient Information Card */}
          <div className="patient-section">
            <PatientInfoCard />
          </div>
        </div>

        {/* Medication Administered */}
        <div className="card">
          <div className="section-header">
            <h4>Medication Administered</h4>
            <button
              type="button"
              className="gradient-button"
              onClick={() => handleAddRow("medication")}
            >
              + Add Medication ({formData.medication.length})
            </button>
          </div>
          <div className="scroll-container">
            {formData.medication.map((med, idx) => (
              <MedicationWardBlock
                key={idx}
                index={idx + 1}
                data={med}
                onChange={(field, value) => handleArrayChange("medication", idx, field, value)}
                onDelete={() => handleDeleteRow("medication", idx)}
              />
            ))}
          </div>
        </div>

        {/* Nursing Notes */}
        <div className="card">
          <div className="section-header">
            <h4>Nursing Notes & Shift Reports</h4>
            <button
              type="button"
              className="gradient-button"
              onClick={() => handleAddRow("nursingNotes")}
            >
              + Add Note ({formData.nursingNotes.length})
            </button>
          </div>
          <div className="scroll-container">
            {formData.nursingNotes.map((note, idx) => (
              <NursingNoteBlock
                key={idx}
                index={idx + 1}
                data={note}
                onChange={(field, value) => handleArrayChange("nursingNotes", idx, field, value)}
                onDelete={() => handleDeleteRow("nursingNotes", idx)}
              />
            ))}
          </div>
        </div>

        {/* Doctor Rounds Log */}
        <div className="card">
          <div className="section-header">
            <h4>Doctor Rounds Log</h4>
            <button
              type="button"
              className="gradient-button"
              onClick={() => handleAddRow("doctorRounds")}
            >
              + Add Round ({formData.doctorRounds.length})
            </button>
          </div>
          <div className="scroll-container">
            {formData.doctorRounds.map((round, idx) => (
              <DoctorRoundBlock
                key={idx}
                index={idx + 1}
                data={round}
                onChange={(field, value) => handleArrayChange("doctorRounds", idx, field, value)}
                onDelete={() => handleDeleteRow("doctorRounds", idx)}
              />
            ))}
          </div>
        </div>

        {/* Lab Tests */}
        <div className="card">
          <div className="section-header">
            <h4>Lab Tests</h4>
            <button
              type="button"
              className="gradient-button"
              onClick={() => handleAddRow("labTests")}
            >
              + Add Test ({formData.labTests.length})
            </button>
          </div>
          <div className="scroll-container">
            {formData.labTests.map((test, idx) => (
              <LabTestBlock
                key={idx}
                index={idx + 1}
                data={test}
                onChange={(field, value) => handleArrayChange("labTests", idx, field, value)}
                onDelete={() => handleDeleteRow("labTests", idx)}
              />
            ))}
          </div>
        </div>

        {/* Diet Plan */}
        <div className="card">
          <h4>Diet & Nutrition Plan</h4>
          <textarea
            placeholder="Enter diet plan details"
            value={formData.dietPlan}
            onChange={(e) => setFormData({ ...formData, dietPlan: e.target.value })}
          />
        </div>

        {/* Special Instructions */}
        <div className="card">
          <h4>Special Instructions</h4>
          <textarea
            placeholder="Enter special instructions"
            value={formData.specialInstructions}
            onChange={(e) =>
              setFormData({ ...formData, specialInstructions: e.target.value })
            }
          />
        </div>

        {/* Submit Button at the End */}
        <div className="submit-container">
          <button className="gradient-button" onClick={handleSubmit}>
            Submit Care Details
          </button>
        </div>
      </div>
    </>
  );
}

export default CareTrackingForm;
